import { columns } from "../../../../dtos/columns";
import { ResultadoRecaudacionEndoso } from "../models/resultadoRecaudacionEndoso";

export function UseColumnsResultados(){

    const COLUMNS_RESULTADOS: columns<ResultadoRecaudacionEndoso>[] = [
        {
            name: 'N° Operación',
            selector: (row: ResultadoRecaudacionEndoso) => row.numeroOperacion,
            sortable: true,
            sortField: 'numeroOperacion',
            wrap: true,
            alling: 'left',
            export: true,
        },
        {
            name: 'Observación',
            selector: (row: ResultadoRecaudacionEndoso) => row.observacion,
            sortable: true,
            sortField: 'observacion',
            wrap: true,
            alling: 'left',
            export: true,
        },
    ]

    return {COLUMNS_RESULTADOS}
}